// import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Service from '../../../../../services/clientmanagement.service';
import moment from 'moment';
import Pagination from './../../../../../../shared/components/pagination';
import CustomExpandableTable from './../../../../../../shared/components/customExpandableTable';
import ClientService from '../../../../../services/clientmanagement.service';
import MasterService from './../../../../../../masterdata/services/masterdata.service';
import ContractTemplateView from './../../../../../../masterdata/views/contracttemplate/contracttemplateview';
import CONSTANT from './../../../../../../shared/constants/constant'

export default {
  name: 'contracts',
  components: {
    VueElementLoading,
    Pagination,
    CustomExpandableTable,
    CONSTANT,
    ContractTemplateView
  },
  props: ['viewRow','shortname','selectclientSystemID','selectBusinessAccId'],
  data: function() {
    return {
      isLoading : false,
      isLoading: false,
      showCreateContractsFlag: false,
      contractid: '',
      clientstatus: '',
      clientId: '',
      clientShortName: '',
      tableColumn: ['Contract ID', 'Contract Name', 'Company Short/Display Name', 'Created Date', 'Start Date', 'End Date','Contract Status', 'Action'],
      innerTableColumn: [],
      tableItems: [],
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: 10,
      contractTemplateList: [],
      selectedContractObj: '',
      createTemplatesFlag: false,
      selectedEditRow: []
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getClientContractList();
  },
  methods: {
    format_date(value){
     if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    async getClientContractList() {
      this.isLoading = true;
      try {
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
          "clientbusinessaccountid": this.selectBusinessAccId
        }

        if (this.contractid != '') {
          inputPayload.contractid = this.contractid;
        }

        let result = await ClientService.getClientContractList(inputPayload);
        this.tableArr = result.data.data.rows;
        this.isLoading = false;
        this.totalCount = result.data.data.count;

        if (this.totalCount > 0) {
          this.tableArr = result.data.data.rows;
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              'id': el.id,
              'Contract ID': el.contractidlabel,
              'Contract Name': el.contractname,
              'Company Short/Display Name': el.clientshortname,
              'Contract Status': CONSTANT.CONTRACT_STATUS[el.contractstatus],
              'Created Date': this.format_date(el.createddate),
              'Start Date': el.contracteffectivedatefrom,
              'End Date': el.contracteffectivedateto,
              'uom': el.uom,
              'Action': 'Need To Check1'
            }
          })
        } else {
          this.tableItems = [];
        }
        if (this.totalCount < 10) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / 10);
        }
      } catch (err) {
        this.isLoading = false;
      }
    },
    getCustomTableEvent(event) {
       if (event.actionType == "view") {
        let selectedViewRow = this.tableItems.filter(function(Items) {
          return Items.id == event.id;
        });
        selectedViewRow[0].view = true;
        this.selectedEditRow = {
          id: selectedViewRow[0].id,
          clientID: selectedViewRow[0]['Client System ID'],
          contractID: selectedViewRow[0]['Contract ID'],
          uom: selectedViewRow[0]['uom'],
          status: selectedViewRow[0].Status,
          view: selectedViewRow[0].view,
        }
        this.selectedEditRow.ComponentName = CONSTANT.CLIENT_CONTRACT_TEMPLATE
        this.createTemplatesFlag = true;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * 10
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/clientlisting/clienteview/contracts/contracts.component.js